import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-inactivity-timer',
  templateUrl: './inactivity-timer.component.html',
  styleUrls: ['./inactivity-timer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class InactivityTimerComponent {
  @Input() countdown: number = 300;

  get formattedTime(): string {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
